import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Confirm from 'views/confirm/confirm'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import cookiesActions from 'redux/actions/cookiesActions'
import { localize } from 'helpers/translator'

const CookiesDisabledConfirm = props => (
	<Confirm
		alertTitle={localize('cookiesNotSupported_title')}
		alertMessage={localize('cookiesNotSupported_subtitle')}
		btTwo={localize('cookiesNotSupported_mainButton')}
		actionOne={props.actions.retry}
		actionTwo={props.actions.learnMore}
		btOne={localize('cookiesNotSupported_secondaryButton')}
		closeAction={props.actions.closeConfirm}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		retry: cookiesActions.cookiesDisabledConfirmRetry,
		learnMore: cookiesActions.goToLearnMore,
		closeConfirm: cookiesActions.closeCookiesDisabledConfirm,
	}, dispatch)
}

CookiesDisabledConfirm.propTypes = {
	actions: PropTypes.shape({
		retry: PropTypes.func.isRequired,
		learnMore: PropTypes.func.isRequired,
		closeConfirm: PropTypes.func.isRequired,
	}).isRequired,
}

export default connect(null, mapDispatchToProps)(CookiesDisabledConfirm)

export { CookiesDisabledConfirm }
